<template>
  <li :class="classObject(source.offLineStatus, source.handleStatus, 'list')"  @click="viewStudent(source, index)" :key="'list_' + index">
    <div class="student-item">
      <div class="left-image" v-if="alarmNum > 0">
        <el-popover
          @hide="showAlarm(source.user_id)"
          placement="right-start"
          :width="language == 'zh' ? 790 : 890"
          popper-class="student-alarm-popper"
          trigger="hover">
          <div class="student-alarm-list" >
            <ul class="student-alarm-ul">
              <li class="first-alarm-item" v-for="(messageItem, messageIndex) in filterMessageList(source, source.user_id)"  :key="'history_' + messageIndex ">
                <AlarmItem
                  :messageItem="messageItem"
                  :item="source"
                  :showType="'list'"
                />
              </li>
            </ul>
          </div>
          <div class="photo" slot="reference" :style="{background: source.offLineStatus ? '#a7b2d2' : colors[index%8]}">
            <span class="name" v-if="source.real_name">{{source.real_name.slice(0, 2)}}</span>
            <span class="name" v-else-if="source.nick">{{source.nick.slice(0, 2)}}</span>
            <div class="alarm-module" v-if="alarmNum > 0">
              <span class="alarm-num">{{alarmNum}}</span>
            </div>
          </div>
        </el-popover>
      </div>
      <div class="left-image" v-else>
        <div class="photo" :style="{background: source.offLineStatus ? '#a7b2d2' : colors[index%8]}">
          <span class="name" v-if="source.real_name">{{source.real_name.slice(0, 2)}}</span>
          <span class="name" v-else-if="source.nick">{{source.nick.slice(0, 2)}}</span>
        </div>
      </div>
      <div class="right-detail">
        <div class="user-info">
          <span class="user-name" v-if="source.real_name">{{source.real_name}}</span>
          <span class="user-name" v-else-if="source.nick">{{source.nick}}</span>
          <span>{{source.data[0].course_sname}}</span>
          <span>{{source.data[0].section_sname}}</span>
          <span>{{source.data[0].topic_sname}}</span>
        </div>
        <ul class="detail-info-ul">
          <li >
            <div class="first-line">
              <i class="iconfont iconanswer" v-if="!source.offLineStatus && source.data[0].event.indexOf('ANSWER') > -1"></i>
              <i class="iconfont iconvideo" v-if="!source.offLineStatus && source.data[0].event.indexOf('VIDEO') > -1"></i>
              <span class="emphasize" v-if="!source.offLineStatus">{{source.data[0] | getEventName(source.data[0].video_type || '')}}</span>
              <span class="emphasize" v-else-if="source.offLineStatus">{{ $t('studentList.studentItem.486417-0') }}</span>
            </div>
            <!-- v-if="source.data[0].flow_id != 1000" -->
            <template >
              <div class="second-line">
                <span>{{ $t('studentList.studentItem.486417-1') }}</span>
                <span>{{current - source.data[0].server_time | parseUserSpentTime}}</span>
              </div>
              <div class="third-line">
                <span class="knowledge-label">{{ $t('studentList.studentItem.486417-2') }}</span>
                <span class="current-knowdlege-name" v-if="source.data[0].tag_sname">{{source.data[0].tag_sname}}</span>
                <span class="current-knowdlege-name" v-else>--</span>
              </div>
            </template>
          </li>
          <li>
            <template v-if="source.data[0].flow_id != 1000">
              <div class="first-line">
                <span class="emphasize" v-if="source.data[0].module_sname">【{{ getModuleName(source.data[0].module_sname) }}】</span>
                <span v-else>--</span>
              </div>
              <div class="second-line">
                <span>{{ $t('studentList.studentItem.486417-3') }}</span>
                <span v-if="source.module_answer" :class="[source.module_answer.rate < 50 ? 'red-num' : '']">{{source.module_answer.rate}}%</span>
                <span v-else>--</span>
              </div>
              <div class="third-line">
                <span>{{ $t('studentList.studentItem.486417-4') }}</span>
                <span v-if="source.module_learn">{{source.module_learn.total_length | formatTime}}</span>
                <span v-else>--</span>
              </div>
            </template>
          </li>
          <li class="count">
            <div class="today-data" v-if="source.data[0].flow_id != 1000">
              <div class="first-line">
                <span v-if="source.today_course_answer" :class="[source.today_course_answer.rate < 50 ? 'num red-num' : 'num']">{{source.today_course_answer.rate}}%</span>
                <span v-else class="num">--</span>
                <span class="small-num" v-if="source.today_course_answer">({{source.today_course_answer.right_total}}/{{source.today_course_answer.total}})</span>
              </div>
              <p class="rate-num">{{ $t('studentList.studentItem.486417-5') }}</p>
            </div>
          </li>
          <li class="count">
            <div class="today-data" v-if="source.data[0].flow_id != 1000">
              <div class="first-line" v-if="source.learning_version != 1">
                <span v-if="source.today_course_knowledge && source.today_course_knowledge.rate" :class="[source.today_course_knowledge.rate < 70 ? 'num red-num' : 'num']">{{source.today_course_knowledge.rate}}%</span>
                <span v-else class="num">--</span>
              </div>
              <div class="first-line" v-else>--</div>
              <p class="rate-num">{{ $t('studentList.studentItem.486417-6') }}</p>
            </div>
          </li>
          <li class="count">
            <div class="today-data">
              <div class="first-line">
                <span class="num" v-if="source.today_course_learn">{{source.today_course_learn.total_length | formatTime}}</span>
                <span class="num" v-else>--</span>
              </div>
              <p class="rate-num">{{ $t('studentList.studentItem.486417-7') }}</p>
            </div>
          </li>
          <li class="option" v-if="!source.offLineStatus">
            <el-dropdown trigger="click">
              <span class="c-more-btn" @click.stop><i class="iconfont icondots"></i></span>
              <el-dropdown-menu slot="dropdown" v-if="source.handleStatus == 2">
                <el-dropdown-item command="a">
                  <span  style="display: block;width: 68px; text-align: center" @click="handleStudentNew(source, index, 3)">{{ $t('studentList.studentItem.486417-8') }}</span>
                </el-dropdown-item>
                <el-dropdown-item command="b">
                  <span  style="display:block;width: 68px; text-align: center" @click="handleStudentNew(source, index, 1)">{{ $t('studentList.studentItem.486417-9') }}</span>
                </el-dropdown-item>
              </el-dropdown-menu>
              <el-dropdown-menu slot="dropdown" v-else-if="source.handleStatus == 3">
                <el-dropdown-item command="a">
                  <span  style="display: block;width: 68px; text-align: center" @click="handleStudentNew(source, index, 2)">{{ $t('studentList.studentItem.486417-10') }}</span>
                </el-dropdown-item>
              </el-dropdown-menu>
              <el-dropdown-menu slot="dropdown" v-else-if="source.handleStatus == 1">
                <el-dropdown-item command="a">
                  <span  style="display: block;width: 68px; text-align: center" @click="handleStudentNew(source, index, 2)">{{ $t('studentList.studentItem.486417-11') }}</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li class="option" v-else>
            <el-dropdown trigger="click">
              <span class="c-more-btn" @click.stop><i class="iconfont icondots"></i></span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="a">
                  <span  style="display: block;width: 68px;text-align: center" @click="closeCardNew(source, index)">{{ $t('studentList.studentItem.486417-12') }}</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul>
      </div>
    </div>
    <div class="has-zgt" v-if="source.data[0].correct_notify > 0">
      <i class="icon-zgtpg"></i>
    </div>
  </li>
</template>

<script>
import { mapGetters } from 'vuex';
import Bus from '@/utils/bus.js';
import i18n from '@/i18n'
import AlarmItem from '@/components/alarmItem';
import { checkAccountDeprived } from '@/api/base';
export default {
  data() {
    return {
      alarmLimitList: ['WARN_WRONG_ANSWER', 'WARN_ANSWER_HESITATE', 'WARN_VIDEO_END_DAZE', 'WARN_VIDEO_PLAYED_SKIP', 'WARN_VIDEO_UNPLAYED_SKIP', 'WARN_ANSWER_TOO_FAST', 'WARN_ANSWER_TOO_SLOW'],
      colors: ['#B7A1FF', '#90DF89', '#E2BC00', '#69DAD8', '#79ACFF', '#459CD7', '#5B78D8', '#A780D8'],
      nowOnlineStudent: {},
      cTimer: null,
      current: 0,
      alarmNum: 0,
      language: 'zh',
    }
  },
  props: {
    index: {
      type: Number
    },
    source: {
      type: Object,
      default () {
        return {}
      }
    },
    messageList: {
      type: Array,
      default() {
        return []
      },
    },
    showType: {
      type: String,
      default: 'list'
    },
    dataNum:{
      type:Number,
      default:0
    },
    studentListCard: {
      type: Array,
      default() {
        return []
      },
    },
    setMessageDisposeStatus: {
      type: Function,
      default: () => {}
    },
    viewStudentDetail: {
      type: Function,
      default: () => {}
    },
    handleStudent: {
      type: Function,
      default: () => {}
    },
    notFollowTaOrFollow: {
      type: Function,
      default: () => {}
    },
    closeCard: {
      type: Function,
      default: () => {}
    },
  },
  components: { AlarmItem },
  computed: {
    ...mapGetters([
      'currentViewStudent',
      'currentUserId',
      'leftStudentCount',
      'pageStudentCard',
      'isCloseLeft'
    ]),
  },
  mounted() {
    const vm = this
    if (typeof vm.cTimer !== 'undefined') clearInterval(vm.cTimer)
    vm.cTimer = setInterval(function() {
      vm.current = new Date().getTime()
    }, 5000)
    this.getAlarmNum();
    // Bus.$on('viewFirstStudent', (isLeft) => {
    //   if (this.studentListCard.length > 0) {
    //     let newStudentArr = this.sortStudentData(this.studentListCard);
    //     let firstStudent = newStudentArr[0];
    //     this.$store.commit('SET_CURRENT_USER_ID', firstStudent['user_id']);
    //     console.log('viewStudentDetail008')
    //     this.viewStudent(firstStudent, 0, isLeft);
    //   }
    // })
  },
  created() {
    i18n.locale = sessionStorage.getItem('Select-language') || 'zh'
    this.language = sessionStorage.getItem('Select-language') || 'zh'
  },
  watch: {
    dataNum:function(newVal, oldVal) {
      this.getAlarmNum()
    }
  //   studentListCard: function(newArr, oldArr) {
  //     if (newArr.length > 0) {
  //       if (this.currentViewStudent['user_id'] == '' && this.$route.path == '/supervise/detail') { // 说明存储在store中的当前学生丢失了，重新去查找
  //         let index = '';
  //         let selectItem = '';
  //         let allCount = 0;
  //         for (let i= 0; i < newArr.length; i++) {
  //           let student = newArr[i];
  //           if (sessionStorage.getItem('user_id') == student['user_id']) {
  //             index = i;
  //             selectItem = student;
  //             break;
  //           }
  //           allCount++;
  //         }
  //         if (index == '' && newArr.length > 0) {
  //           index = 0;
  //           selectItem = newArr[0];
  //         }
  //         this.viewStudent(selectItem, index, 'left');
  //         this.onlineStudentCount = allCount;
  //         this.nowOnlineStudent = {};
  //         this.nowOnlineStudent['count'] = allCount;
  //       }
  //     }
  //   },
  },
  methods: {
    getModuleName (moduleName) {
      const lang = this.language
      if (lang === 'en') {
        if (moduleName === '测试') {
          return 'Test'
        }
        if (moduleName === '学习') {
          return 'Learning'
        }
        if (moduleName === '重学') {
          return 'Restudy'
        }
        if (moduleName === '补漏测') {
          return 'Knowledge gap assessment'
        }
        if (moduleName === '补漏学') {
          return 'Knowledge gap learning'
        }
        if (moduleName === '章节结束') {
          return 'Chapter ends'
        }
      }
      return moduleName
    },
    async viewStudent (val, index, isLeft) {
      try {
        const { data = {} } = await checkAccountDeprived({ account_id:  val.data[0].account_id, function_id: 6266002, restrict_type: 6261003, subject_id: val.data[0].subject_id });
        const { is_limit, restrict_reason, restrict_function_name } = data
        if(is_limit){
          const message = `此学员不可使用${restrict_function_name}功能。限制原因：${restrict_reason}`
          this.$message.error(message)
          return
        }
      } catch (error) {
        console.error('Error checking function limit:', error);
      }
      const cardtop = this.studentListCard.filter(card => card.user_id == (typeof val.user_id !== 'undefined' ? val.user_id + '' : val + ''))
      if (typeof index !== 'undefined' && cardtop.length > 0) {
        cardtop[0].index = index
      } else {
        cardtop[0].index = typeof val.index !== 'undefined' ? val.index : cardtop[0].index
      }
      this.cardTop = cardtop
      const vm = this
      const user_id = typeof val.user_id !== 'undefined' ? val.user_id + '' : val + ''
      console.log('user_id========='+user_id);
      // debugger
      const st = vm.studentListCard.filter(event_cell => event_cell.user_id == user_id)
      // debugger
      console.log('863', st)
      const qId = (typeof st[0].data[0].question_ids !== 'undefined' && st[0].data[0].question_ids instanceof Array) ? st[0].data[0].question_ids.join(',') : ''
      console.log(qId)
      const topic_id = typeof st[0].data[0].topic_id !== 'undefined' ? st[0].data[0].topic_id : ''
      const subject_id = typeof st[0].data[0].subject_id !== 'undefined' ? st[0].data[0].subject_id : ''
      const school_id = typeof st[0].data[0].school_id !== 'undefined' ? st[0].data[0].school_id : ''
      const exam_else_info = typeof st[0].data[0].exam_else_info !== 'undefined' ? st[0].data[0].exam_else_info : ''
      const flow_id = typeof st[0].data[0].flow_id !== 'undefined' ? st[0].data[0].flow_id : ''
      const jupiter_stage = typeof st[0].data[0].stage !== 'undefined' ? st[0].data[0].stage : ''
      const course_id = typeof st[0].data[0].course_id !== 'undefined' ? st[0].data[0].course_id : ''
      // const learning_version = typeof st[0].data[0].learning_version !== 'undefined' ? st[0].data[0].learning_version : ''
      const module_type = typeof st[0].data[0].module_type !== 'undefined' ? st[0].data[0].module_type : ''
      const module_name = typeof st[0].data[0].module_name !== 'undefined' ? st[0].data[0].module_name : ''
      const lesson_id = typeof st[0].data[0].lesson_id !== 'undefined' ? st[0].data[0].lesson_id : ' '
      const knowledge_code = typeof st[0].data[0].tag_code !== 'undefined' ? st[0].data[0].tag_code : ' '
      const question_bank_version = typeof st[0].data[0].question_bank_version !== 'undefined' ? st[0].data[0].question_bank_version : ''
      const question_vno = typeof st[0].data[0].question_vno !== 'undefined' ? st[0].data[0].question_vno : 0
      const account_id = val.data[0].account_id
      const stage = typeof st[0].data[0].stage !== 'undefined' ? st[0].data[0].stage : ''
      const q_forms = typeof st[0].data[0].q_forms !== 'undefined' ? st[0].data[0].q_forms : ''
      const learning_version = cardtop[0]['course_version'];

      let photoColor = '';
      if(typeof (index) === "undefined" && this.currentViewStudent.photoColor){
        photoColor = this.currentViewStudent.photoColor;
      }else{
        photoColor = vm.colors[typeof (index) !== "undefined" ? index % 8 : 0 % 8];
      }
      let today_course_answer = {};
      let today_course_knowledge = {};
      let today_course_learn = {};
      let module_answer = {};
      let module_learn = {};

      let getQuestionServerTime = '';

      if (st[0].data[0].event == 'GET_QUESTION') {
        getQuestionServerTime = st[0].data[0].server_time;
      }

      if (typeof (cardtop[0].today_course_answer) !='undefined') {
        today_course_answer = cardtop[0].today_course_answer;
      }

      if (typeof (cardtop[0].today_course_knowledge) !='undefined') {
        today_course_knowledge = cardtop[0].today_course_knowledge;
      }

      if (typeof (cardtop[0].today_course_learn) !='undefined') {
        today_course_learn = cardtop[0].today_course_learn;
      }

      if (typeof (cardtop[0].module_answer) !='undefined') {
        module_answer = cardtop[0].module_answer;
      }
      if (typeof (cardtop[0].module_learn) !='undefined') {
        module_learn = cardtop[0].module_learn;
      }

      let eventMessage = '';
      if (st[0].data[0].event) {
        eventMessage = st[0].data[0].event;
      }
      this.setMessageDisposeStatus(user_id);
      this.viewStudentDetail(val, index);
      this.$store.commit("SET_CURRENT_VIEW_STUDENT", {
        exam_else_info,
        school_id,
        user_id,
        course_id,
        topic_id,
        lesson_id,
        account_id,
        knowledge_code,
        stage,
        flow_id,
        subject_id,
        jupiter_stage,
        learning_version,
        question_bank_version,
        question_vno,
        photoColor,
        qId,
        msg: '',
        eventMessage,
        module_type,
        module_name,
        today_course_answer,
        today_course_knowledge,
        today_course_learn,
        module_answer,
        module_learn,
        getQuestionServerTime,
        q_forms
      });
      this.$store.commit('SET_CURRENT_USER_ID', user_id);
      if (this.pageStudentCard['msg'] == '') { // 说明缓存里面没有值
        let tempPageStudentCard = {
          val: val,
          index: typeof index !== 'undefined' ? index : -1,
          studentListCard: this.studentListCard,
          msg: 'detail'
        }
        this.$store.commit('SET_PAGE_STUDENT_CARD', tempPageStudentCard)
      }
      if (!isLeft && this.$route.path != "/supervise/detail") {
        this.$router.push({ path: '/supervise/detail', query: {} });
      }
    },
    classObject (offLineStatus, handleStatus, user_id, is_not_follow, type) {
      if (type == 'leftPage') { // 左侧列表
        if (offLineStatus) { // 离线
          return 'student-module offLine';
        } else {
          if (handleStatus == 1) { // 不关注他
            return 'student-module not-attention';
          } else { // 正常
            return 'student-module';
          }
        }
      } else if (type == 'leftList') {
        let classResult = '';
        if (user_id == this.currentUserId) {
          classResult = 'single-item active';
        } else {
          classResult = 'single-item';
        }
        if (is_not_follow == 1) {
          classResult += 'not-follow';
        }
        return classResult;
      } else { // list
        if (offLineStatus) { // 离线
          return 'single-student offLine';
        } else {
          if (handleStatus == 1) { // 不关注他
            return 'single-student not-attention';
          } else { // 正常
            return 'single-student';
          }
        }
      }
    },
    getAlarmNum (val) {
      console.log(2222226,val)
      const vm = this
      // let count = 0;
      //let notHandleMessageList = vm.messageList.filter(item => item.disposeStatus === false)
      //let newMessageList = this.uniqeByKeys(notHandleMessageList, ['c_time', 'user_id'])
      let newMessageList = this.source.data.filter(item=>this.alarmLimitList.indexOf(item.event) > -1 && item.disposeStatus === false)
      //newMessageList.forEach(item => {
        //if (val.user_id == item.user_id) {
          //count++;
        //}
      //})
      this.alarmNum = newMessageList.length
      return newMessageList.length;
    },
    uniqeByKeys(array, keys) {
      var allArr = []
      for (var i = 0; i < array.length; i++) {
        var flag = true
        for (var j = 0; j < allArr.length; j++) {

          if (array[i].user_id === allArr[j].user_id && array[i].event === allArr[j].event && Math.abs(array[i].c_time - allArr[j].c_time) <= 1000 && !eventCheck) {
            flag = false
          }
        }
        let eventCheck = this.alarmLimitList.some((item)=>{
          return item == array[i].event
        })
        if (flag && eventCheck) {
          allArr.push(array[i])
        }
      }
      return allArr
    },
    // 显示报警，将当前的学生的报警数量设置为0
    showAlarm (user_id) {
      console.log(222222)
      this.$emit('setMessageDisposeStatus', user_id);
    },
    // 置顶/取消置顶 暂时不看他/重新关注ta
    handleStudentNew (selectItem, selectIndex, status) {
      let currentTime = new Date().getTime();
      if (!!sessionStorage.getItem('studentCardX')) { // 说明之前已经存储过学生列表的顺序了
        let studentCardX = sessionStorage.getItem('studentCardX');
        let studentCardArr = JSON.parse(studentCardX);
        // 判断当前学生是否存储过
        let findIndex =  -1;
        for (let i=0; i < studentCardArr.length; i++ ) {
          let studentCardItem = studentCardArr[i];
          if (studentCardItem['user_id'] == selectItem['user_id']) {
            findIndex = i;
            break;
          }
        }
        if (findIndex == -1) { // 说明该学生之前没有操作过置顶、不看他
          studentCardArr.push({
            user_id: selectItem['user_id'],
            handleStatus: status,
            handleTime: currentTime
          })
          sessionStorage.setItem('studentCardX', JSON.stringify(studentCardArr));
        } else { // 该学生被操作过置顶、不看他，直接从sessionStorage中移除掉
          studentCardArr.splice(findIndex, 1);
          sessionStorage.setItem('studentCardX', JSON.stringify(studentCardArr));
        }
      } else {
        let studentCardX = [];
        let firstStudent = {
          user_id: selectItem['user_id'],
          handleStatus: status,
          handleTime: currentTime
        }
        studentCardX.push(firstStudent);
        sessionStorage.setItem('studentCardX', JSON.stringify(studentCardX));
      }
      this.handleStudent(selectItem, selectIndex, status);
    },
    closeCardNew(params) {
      this.closeCard(params);
    },
    // 显示排序的
    sortStudentData(data) {
      let newData = data.slice();
      newData.slice().sort((a,b) => b.offLineStatus - a.offLineStatus);
      let onlineStudent = [];
      let offLineStudent = [];
      newData.map(item => {
        if (!item['offLineStatus']) { // 在线
          let lastUserName = '';
          if (item['real_name']) {
            lastUserName = item['real_name'];
          } else {
            lastUserName = item.data[0].real_sname || item.data[0].nick
          }
          item['lastUserName'] = lastUserName;
          onlineStudent.push(item);
        } else {
          let lastUserName = '';
          if (item['real_name']) {
            lastUserName = item['real_name'];
          } else {
            lastUserName = item.data[0].real_sname || item.data[0].nick
          }
          item['lastUserName'] = lastUserName;
          offLineStudent.push(item);
        }
      })
      if (!!sessionStorage.getItem('studentCardX')) {
        let studentCardXArr = JSON.parse(sessionStorage.getItem('studentCardX'));
        if (studentCardXArr.length == 0) {
          onlineStudent.map((item, index) => {
            let newItem = item;
            newItem['handleStatus'] = 2;
            this.$set(onlineStudent, index, newItem);
          })
          onlineStudent = onlineStudent.sort(function compareFunction(item1, item2) {
            let studentName1 = item1['real_name'] || item1['nick'] || item1['uname'];
            let studentName2 = item2['real_name'] || item2['nick'] || item2['uname'];
            return studentName1.localeCompare(studentName2);
          });
          offLineStudent = offLineStudent.sort(function compareFunction(item1, item2) {
            let studentName1 = item1['real_name'] || item1['nick'] || item1['uname'];
            let studentName2 = item2['real_name'] || item2['nick'] || item2['uname'];
            return studentName1.localeCompare(studentName2);
          });
          return onlineStudent.concat(offLineStudent);
        } else {
          let topStudentArr = [];
          let normalStudentArr = [];
          let bottomStudentArr = [];
          for (let i=0; i < onlineStudent.length; i++) {
            let dataItem = onlineStudent[i];
            let isExist = false;
            for (let j=0; j < studentCardXArr.length; j++ ) {
              let cardItem = studentCardXArr[j];
              if (dataItem['user_id'] == cardItem['user_id']) {
                isExist = true;
                if (cardItem['handleStatus'] == 1) { // 暂时不看他
                  dataItem['handleStatus'] = 1;
                  dataItem['handleTime'] = cardItem['handleTime'];
                  bottomStudentArr.push(dataItem);
                } else if (cardItem['handleStatus'] == 3) { // 置顶
                  dataItem['handleStatus'] = 3;
                  dataItem['handleTime'] = cardItem['handleTime'];
                  topStudentArr.push(dataItem);
                }
                break;
              } else {
                isExist = false;
              }
            }

            if (!isExist) {
              normalStudentArr.push(dataItem);
            }
          }
          // topStudentArr = topStudentArr.sort((a,b) => a.handleTime - b.handleTime);
          topStudentArr = topStudentArr.sort(function compareFunction(item1, item2) {
            if (item1['real_name'] && item2['real_name']) {
              return item1['real_name'].localeCompare(item2['real_name']);
            }
          });
          normalStudentArr = normalStudentArr.sort(function compareFunction(item1, item2) {
            if (item1['real_name'] && item2['real_name']) {
              return item1['real_name'].localeCompare(item2['real_name']);
            }
          });
          bottomStudentArr = bottomStudentArr.sort(function compareFunction(item1, item2) {
            if (item1['real_name'] && item2['real_name']) {
              return item1['real_name'].localeCompare(item2['real_name']);
            }
          });
          let lastArr = topStudentArr.concat(normalStudentArr).concat(bottomStudentArr).concat(offLineStudent);
          return lastArr
        }
      } else { // 说明之前没操作过置顶、不看他
        onlineStudent.map((item, index) => {
          let newItem = item;
          newItem['handleStatus'] = 2;
          this.$set(onlineStudent, index, newItem);
        })
        onlineStudent = onlineStudent.sort(function compareFunction(item1, item2) {
          if (item1['real_name'] && item2['real_name']) {
            return item1['real_name'].localeCompare(item2['real_name']);
          }
        });
        offLineStudent = offLineStudent.sort(function compareFunction(item1, item2) {
          if (item1['real_name'] && item2['real_name']) {
            return item1['real_name'].localeCompare(item2['real_name']);
          }
        });
        let lastArr = onlineStudent.concat(offLineStudent);
        return lastArr
      }
    },
    filterMessageList(messageList, user_id) {
      return messageList.data.filter(item => {
        return item.disposeStatus === false && this.alarmLimitList.indexOf(item.event) > -1;
      })
    },
  },
  filters: {
    parseTime(time) {
      if (arguments.length === 0) {
        return null
      }
      const format = '{y}-{m}-{d} {h}:{i}:{s}'
      let date
      if (typeof time === 'object') {
        date = time
      } else {
        if (('' + time).length === 10) time = parseInt(time) * 1000
        date = new Date(time)
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
      }
      const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        if (key === 'a') return [i18n.t('studentList.studentItem.486417-13'), i18n.t('studentList.studentItem.486417-14'), i18n.t('studentList.studentItem.486417-15'), i18n.t('studentList.studentItem.486417-16'), i18n.t('studentList.studentItem.486417-17'), i18n.t('studentList.studentItem.486417-18'), i18n.t('studentList.studentItem.486417-19')][value - 1]
        if (result.length > 0 && value < 10) {
          value = '0' + value
        }
        return value || 0
      })
      return time_str
    },
    parseUserSpentTime(msd) {
      var time = parseFloat(msd) / 1000
      if (time !== null && time !== '') {
        // 当答题用时超过30分钟时，只显示30分钟
        if (time > 30 * 60) {
          time = 30 * 60
        }
        if (time > 60 && time < 60 * 60) {
          time = parseInt(time / 60.0) + i18n.t('studentList.studentItem.486417-20') + parseInt((parseFloat(time / 60.0) -
            parseInt(time / 60.0)) * 60) + i18n.t('studentList.studentItem.486417-21')
        } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
          time = parseInt(time / 3600.0) + i18n.t('studentList.studentItem.486417-22') + parseInt((parseFloat(time / 3600.0) -
            parseInt(time / 3600.0)) * 60) + i18n.t('studentList.studentItem.486417-20') +
            parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) -
              parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + i18n.t('studentList.studentItem.486417-21')
        } else {
          if (isNaN(time)) {
            return i18n.t('studentList.studentItem.486417-23')
          } else {
            if (time < 0) {
              time = 0
            }
            time = parseInt(time) + i18n.t('studentList.studentItem.486417-21')
          }
        }
      }
      return time
    },
    // 卡片事件
    getEventName(val, videoType) {
      let that = this;
      let eventName = ''
      let typeStr = ''

      if (videoType == 'IMPORT') {
        typeStr = i18n.t('studentList.studentItem.486417-24');
      } else if (videoType == 'KNOWLEDGE') {
        typeStr = i18n.t('studentList.studentItem.486417-25');
      } else if (videoType == 'QTID') {
        typeStr = i18n.t('studentList.studentItem.486417-26');
      } else if (videoType == 'ANALYZE') {
        typeStr = i18n.t('studentList.studentItem.486417-27');
      } else if (videoType == 'ERRORCAUSE') {
        typeStr = i18n.t('studentList.studentItem.486417-28');
      } else if (videoType == 'SKILL') {
        typeStr = i18n.t('studentList.studentItem.486417-29');
      } else if (videoType == 'QUESTION') {
        typeStr = i18n.t('studentList.studentItem.486417-30');
      } else if (videoType == 'TAIL') {
        typeStr = '片尾（学习流程结束)';
      }

      switch (val.event) {
        case 'LOGIN':
          eventName = i18n.t('studentList.studentItem.486417-32')
          break
        case 'RELOGIN':
          eventName = i18n.t('studentList.studentItem.486417-33')
          break
        case 'MODULE_START':
          eventName = i18n.t('studentList.studentItem.486417-34')
          break
        case 'GET_QUESTION':
          if (val.hasOwnProperty('question_round')) {
            if (val.question_round == 1) {
              eventName = i18n.t('studentList.studentItem.486417-35')
            } else if (val.question_round == 2) {
              eventName = i18n.t('studentList.studentItem.486417-36')
            }
          } else {
            eventName = i18n.t('studentList.studentItem.486417-37')
          }
          break
        case 'GET_QUESTION':
          eventName = i18n.t('studentList.studentItem.486417-37')
          break
        case 'SUBMIT_ANSWER':
          eventName = val.flow_id == 1000 ? '考试结束' : i18n.t('studentList.studentItem.486417-38')
          break
        case 'GET_ANALYSIS':
          if (val.hasOwnProperty('question_round')) {
            if (val.question_round == 1) {
              eventName = i18n.t('studentList.studentItem.486417-39')
            } else if (val.question_round == 2) {
              eventName = i18n.t('studentList.studentItem.486417-40')
            }
          } else {
            eventName = i18n.t('studentList.studentItem.486417-41')
          }
          break
        case 'GET_QLIST':
          eventName = i18n.t('studentList.studentItem.486417-42')
          break
        case 'GET_REPORT':
          eventName = i18n.t('studentList.studentItem.486417-43')
          break
        case 'VIDEO_PLAY':
          console.log('videoType='+videoType)
          eventName = i18n.t('studentList.studentItem.486417-44') + typeStr + i18n.t('studentList.studentItem.486417-45')
          break
        case 'VIDEO_CLOSE':
          eventName = i18n.t('studentList.studentItem.486417-12') + typeStr + i18n.t('studentList.studentItem.486417-45')
          break
        case 'VIDEO_END':
          eventName = i18n.t('studentList.studentItem.486417-46')
          break
        case 'VIDEO_PAUSE':
          eventName = i18n.t('studentList.studentItem.486417-47') + typeStr + i18n.t('studentList.studentItem.486417-45')
          break
        case 'VIDEO_DRAG':
          eventName = i18n.t('studentList.studentItem.486417-48') + typeStr + i18n.t('studentList.studentItem.486417-45')
          break
        case 'VIDEO_BACK':
          eventName = i18n.t('studentList.studentItem.486417-49') + typeStr + i18n.t('studentList.studentItem.486417-45')
          break
        case 'VIDEO_SKIP':
          eventName = i18n.t('studentList.studentItem.486417-50') + typeStr + i18n.t('studentList.studentItem.486417-45')
          break
        case 'VIDEO_END_DAZE':
          eventName = i18n.t('studentList.studentItem.486417-51')
          break
        case 'VIDEO_PAUSE_DAZE':
          eventName = i18n.t('studentList.studentItem.486417-52')
          break
        case 'VIDEO_UNPLAYED_SKIP':
          eventName = i18n.t('studentList.studentItem.486417-53')
          break
        case 'NO_ACTION':
          eventName = i18n.t('studentList.studentItem.486417-54')
          break
        case 'WARN_VIDEO_UNPLAYED_SKIP':
          eventName = i18n.t('studentList.studentItem.486417-55')
          break
        case 'WARN_VIDEO_PLAYED_SKIP':
          eventName = i18n.t('studentList.studentItem.486417-56')
          break
        case 'WARN_VIDEO_PAUSE_DAZE':
          eventName = i18n.t('studentList.studentItem.486417-52')
          break
        case 'WARN_VIDEO_END_DAZE':
          eventName = i18n.t('studentList.studentItem.486417-51')
          break
        case 'WARN_NO_ACTION':
          eventName = i18n.t('studentList.studentItem.486417-57')
          break
        case 'ANSWER_HESITATE':
          eventName = i18n.t('studentList.studentItem.486417-58')
          break
        case 'WARN_ANSWER_HESITATE':
          eventName = i18n.t('studentList.studentItem.486417-58')
          break
        // case 'WARN_MODULE_END':
        //   eventName = '模块完成报警'
        //   break
        case 'WARN_WRONG_ANSWER':
          eventName = i18n.t('studentList.studentItem.486417-59')
          break
        case 'MODULE_END':
          eventName = i18n.t('studentList.studentItem.486417-60')
          break
        case 'TAG_CODE_END':
          eventName = i18n.t('studentList.studentItem.486417-61')
          break
        case 'WARN_ANSWE_TOO_SLOW':
          eventName = i18n.t('studentList.studentItem.486417-62')
          break
        case 'WARN_ANSWE_TOO_FAST':
          eventName = i18n.t('studentList.studentItem.486417-63')
          break
        default:
          eventName = i18n.t('studentList.studentItem.486417-23')
      }
      return eventName
    },
    formatTime (s) {
      let result = '';
      if (s == 0) {
        result = i18n.t('studentList.studentItem.486417-64');
      } else {
        var day = Math.floor( s/ (24*3600) ); // Math.floor()向下取整
        var hour = Math.floor( (s - day*24*3600) / 3600);
        var minute = Math.floor( (s - day*24*3600 - hour*3600) /60 );
        var second = s - day*24*3600 - hour*3600 - minute*60;

        if (day > 0) {
          result = i18n.t('studentList.studentItem.486417-65', [day])
        }

        if (hour > 0) {
          result += i18n.t('studentList.studentItem.486417-66', [hour])
        }

        if (minute > 0) {
          result += i18n.t('studentList.studentItem.486417-67', [minute])
        }

        if (second > 0) {
          result += i18n.t('studentList.studentItem.486417-68', [second])
        }
      }
      // return day + "天"  + hour + "时" + minute + "分" + second + i18n.t('studentList.studentItem.486417-21');
      return result;
    }
  }
}
</script>

<style lang="scss" scoped>
  .single-student {
    position: relative;
    box-sizing: content-box;
    min-height: 130px;
    margin-bottom: 11px;
    overflow: hidden;
    clear: both;
    background: rgba(255,255,255,1);
    border-radius: 8px;
    box-shadow: 0 6px 12px 0 rgba(68,75,101,.06);
    .student-item {
      display: flex;
      .left-image {
        float: left;
        width: 60px;
        // height: 180px;
        padding: 12px 12px 12px 24px;
        .photo {
          position: relative;
          display: flex;
          align-items: center;
          width: 58px;
          height: 58px;
          text-align: center;
          background: #69dad8;
          border-radius: 100px;
          .name {
            width: 58px;
            height: 15px;
            font-size: 20px;
            font-weight: 400;
            line-height: 15px;
            color: rgba(255,255,255,1);
          }
        }
      }
      .right-detail {
        position: relative;
        float: left;
        width: 1204px;
        padding: 12px 0;
        .user-info {
          font-size: 14px;
          color: #868a9b;
          .user-name {
            display: inline-block;
            height: 28px;
            margin-right: 19px;
            font-size: 16px;
            font-weight: 600;
            line-height: 28px;
            color: rgba(68,75,101,1);
          }
        }
        .detail-info-ul {
          display: flex;
          overflow: hidden;
          li {
            float: left;
            width: 25%;
            color: #858a9b;
            .emphasize {
              height: 25px;
              font-size: 16px;
              font-weight: 600;
              line-height: 25px;
              color: rgba(68,75,101,1);
            }
            .num {
              height: 20px;
              font-size: 20px;
              font-weight: 500;
              line-height: 20px;
              color: #2980ff;
              &.red-num {
                color: #ff4757;
              }
            }
            .today-data {
              // width: 140px;
              // text-align: center;
            }
            .first-line {
              margin-bottom: 7px;
              .module_sname_label {
                color: #444b65;
              }
              .small-num {
                font-size: 12px;
              }
            }
            .second-line {
              margin-bottom: 7px;
              font-size: 14px;
              .red-num {
                color: #ff4757;
              }
            }
            .third-line {
              // margin-bottom: 12px;
              font-size: 14px;
              display: flex;
              .knowledge-label {
                min-width: 60px;
              }
              .current-knowdlege-name {
                max-height: 40px;
                max-width: 160px;
                // text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                // display: -webkit-box;
                // -webkit-line-clamp: 2;
                // line-clamp: 2;
                // -webkit-box-orient: vertical;
              }
            }
            &.count {
              // width: 180px;
              .rate-num {
                font-size: 14px;
              }
            }
            &.is-jieru {
              width: 80px;
            }
            &.option {
              float: right;
              width: 50px;
              margin-right: 23px;
              text-align: right;
            }
          }
        }
        .now-jieru {
          position: absolute;
          right: 0;
          bottom: -21px;
          width: 110px;
          height: 73px;
        }
      }
    }
    &:hover {
      cursor: pointer;
      border: 1px solid rgba(41,128,255,1);
    }
    .has-zgt {
      position: absolute;
      top: 0;
      right: 0;
    }
    &.not-attention {
      background: #f3f6fd;
    }
    &.offLine {
      background: #f5f5f5;
    }
  }
  .single-item {
      position: relative;
      box-sizing: border-box;
      height: 61px;
      .student-module {
        box-sizing: border-box;
        height: 61px;
        padding: 11px 10px 10px 6px;
        overflow: hidden;
        border-bottom: 1px solid #d3d8e8;
        display: flex;
        .left-side {
          float: left;
          width: 32px;
          height: 45px;
          margin-top: 3px;
          // padding-left: 9px;
          .photo-content {
            position: relative;
            display: flex;
            align-items: center;
            width: 32px;
            height: 32px;
            text-align: center;
            background: #69dad8;
            border-radius: 100px;
            .name {
              width: 32px;
              height: 12px;
              font-size: 12px;
              font-weight: 400;
              line-height: 12px;
              color: #fff;
            }
          }
          .alarm-module {
            top: -7px;
            right: -3px;
          }
        }
        .right-side {
          position: relative;
          float: left;
          margin-left: 12px;
          .user-name-x {
            position: relative;
            margin-bottom: 4px;
            font-size: 14px;
            font-weight: 500;
            color: rgba(68,75,101,1);
            .left-user-name {
              position: relative;
              display: flex;
              align-items: center;
              .student-name {
                width: 60px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
              }
            }
            .wait-correct {
              position: absolute;
              right: -4px;
              top: -11px;
            }
          }
          .module {
            width: 200px;
            margin-left: -7px;
            overflow: hidden;
            font-size: 12px;
            font-weight: 400;
            color: #696f84;
            text-overflow: ellipsis;
            white-space: nowrap;
            &.empty {
              margin-left: 3px;
            }
          }
          .current-option {
            width: 133px;
            // height: 20px;
            margin-left: 8px;
            // margin-bottom: 8px;
            font-size: 12px;
            font-weight: 400;
            // line-height: 20px;
            color: #2980ff;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .jieru {
            position: absolute;
            right: -20px;
            bottom: -7px;
          }
          .answer-question-detail {
            display: flex;
            li {
              .num-rate {
                font-size: 14px;
                font-weight: 400;
                color: rgba(68,75,101,1);
                &.red {
                  color: #ff4757;
                }
              }
              .rate-text {
                font-size: 14px;
                font-weight: 400;
                color: rgba(68,75,101,.4);
              }
              &:first-child {
                margin-right: 41px;
              }
            }
          }

        }
        .handle {
          position: absolute;
          top: 12px;
          right: 8px;
          width: 40px;
          height: 40px;
        }
        &.not-attention {
          background: #f3f6fd;
        }
        &.offLine {
          background: #f5f5f5;
        }
      }
      &:last-child {
        border-bottom: none;
      }
      // .wait-correct {
      //   position: absolute;
      //   top: 0;
      //   right: 0;
      // }
      &.active {
        background: #F3F6FD;
      }
      &.not-follow {
        background: #f5f8ff;
        .student-module {
          .right-side {
            .user-name-x {
              color: #a7b2d2;
            }
            .module {
              color: #a7b2d2;
            }
            .current-option {
              color: #a7b2d2;
            }
          }
        }
      }
    }
</style>


// WEBPACK FOOTER //
// src/views/studentList/studentItem.vue